import { Injectable } from '@angular/core';
import { endpoint } from '@tekman/onmat/constants';
import { ApiService } from '@tekman/onmat/service/generic';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private readonly apiService: ApiService) {}

  getProfile(): Observable<any> {
    return this.apiService.get<any>(endpoint.user.profile);
  }
}
